import api from './api'

const services = {
    publicKey() {
        return api().get('push/public-key')
    },
    subscribe(subscription) {
        return api().post('push/subscribe', subscription)
    },
    unsubscribe(endpoint) {
        return api().delete('push/subscribe', { data: { endpoint } })
    }
}

export default services
